import { Spreadsheet, getRangeAddress } from '@syncfusion/ej2-spreadsheet';
import { Uploader } from '@syncfusion/ej2-inputs';
import { ExcelWorksheetCellModel, ExcelWorksheetModel, SetWorkbookDataModel } from '../../Models/Excel/SetWorkbookDataModel';
import { ExcelDataService } from '../../DataService/ExcelDataService';
import { EventDispatcher } from "strongly-typed-events";

import { L10n } from '@syncfusion/ej2-base';
import { Toastr } from '../../Helpers/Toastr';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { CompanyPlugin } from '../../Models/Common/CompanyPlugin';
import { CommonDataService } from '../../DataService/CommonDataService';

export class UploadExcelWorkbookManager {

    constructor(private containerElement: JQuery) { }

    private uploadContainer : JQuery<HTMLElement>;
    private fileUploadInput : JQuery<HTMLElement>;
    
    public uploadContainerCreatedEvent = new EventDispatcher<UploadExcelWorkbookManager, undefined>();
    public workbookSetEvent = new EventDispatcher<UploadExcelWorkbookManager, undefined>();
    public workbookOpenFailedEvent = new EventDispatcher<UploadExcelWorkbookManager, undefined>();
    public workbookUploadingEvent = new EventDispatcher<UploadExcelWorkbookManager, undefined>();

    public initialize() {
        var self = this;

        self.uploadContainer = self.containerElement.find('#upload-excel-workbook-container');
        self.fileUploadInput = self.containerElement.find('#file-upload-input');

        self.initializeUploadAndWorkbooksTable();
    }

    private initializeUploadAndWorkbooksTable() {
        var self = this;

        L10n.load({
            "en-US": {
                "uploader": { 
                    "dropFilesHint" : "Drop a file here"
                }
            }
        })

        var uploadObject : Uploader;
        

        var checkForFile = true;

        CommonDataService.isCompanyPluginActive(CompanyPlugin.AiImporter, (pdfUploadAllowed) => {

            var allowedUploadExtensions = '.csv, .xls, .xlsx, .xlsm';
            if(pdfUploadAllowed) {
                allowedUploadExtensions = '.csv, .xls, .xlsx, .xlsm, .pdf, .doc, .docx, .docm';
            }

            uploadObject = new Uploader({
                maxFileSize: 40000000,
                asyncSettings: {
                    saveUrl: '/api/company/file/uploadfile',
                    removeUrl: '/api/company/excel/removefile'
                },
                multiple: false,
                allowedExtensions: allowedUploadExtensions,                
                created: () => {
                    self.uploadContainerCreatedEvent.dispatch(this, undefined);
                    self.uploadContainer.removeClass('d-none');

                    checkForFile = true;
                },
                beforeUpload: (args) => {
                    if(checkForFile) {
                        args.cancel = true;

                        var fileName = uploadObject.getFilesData(0)[0].name;

                        //TODO: Not only excel but also other files.
                        ExcelDataService.doesFileExist(fileName, (result) => {
                            if(result) {
                                new ConfirmModal().initialize('File already exist', `We already have a file with name '${fileName}' within our system.</br>Are you sure you want to upload this file?`, () => {
                                    checkForFile = false;
                                    uploadObject.upload();
                                }, () => {
                                    checkForFile = true;
                                    uploadObject.clearAll();
                                }, 'Confirm', 'Cancel')
                            }
                            else {
                                checkForFile = false;
                                uploadObject.upload();
                            }
                        })
        
                        return;
                    }
                    
                    //spreadsheet.destroy();
                },
                uploading: () => {
                    self.workbookUploadingEvent.dispatch(this, undefined);
                },
                success: (args: any) => {  
                    checkForFile = true;   

                    if (args.operation == 'upload') {
                        if(pdfUploadAllowed && (args.file.type == 'pdf' || args.file.type == 'PDF')) {
                            Toastr.Success("PDF uploaded", "The PDF was successfully uploaded in the system. We've queued the file to be imported.");
                            if(uploadObject != undefined) {
                                uploadObject.clearAll();
                                //TODO: move to AI page?
                                //self.workbookSetEvent.dispatch(this, undefined);
                            }
                        }
                        else if(pdfUploadAllowed && (args.file.type == 'doc' || args.file.type == 'docx' || args.file.type == 'docm')) {
                            Toastr.Success("Word document uploaded", "The word document was successfully uploaded in the system. We've queued the file to be imported.");
                            if(uploadObject != undefined) {
                                uploadObject.clearAll();
                            }
                        }
                        else {
                            var uploadedWorkbookId = args.e.target.response;
                            if(uploadedWorkbookId == undefined) {
                                self.workbookOpenFailedEvent.dispatch(this, undefined);
                            }
                            else {
                                if(uploadObject != undefined) {
                                    uploadObject.clearAll();
                                    self.workbookSetEvent.dispatch(this, undefined);
                                }
                                else {
                                    self.workbookOpenFailedEvent.dispatch(this, undefined);
                                }
                            }

                        }
                    }
                },
            });

            var fileInput = self.fileUploadInput.get(0);

            // render initialized Uploader
            uploadObject.appendTo(fileInput);
            self.fileUploadInput.removeClass('d-none');
            
        });
    }

}